import { gql } from "graphql-request";

export const ClassicReportFieldsFragment = gql`
  fragment ClassicReportFieldsFragment on ClassicReportSearchResult {
    classicReportId
    name
    subdomain
  }
`;
